import en from './locale/en';
import pt_BR from './locale/pt_BR';

// Só en + pt_BR entram no bundle inicial — são os idiomas mantidos pelo fork.
// Os demais locales (~38 idiomas × ~40 JSONs cada) são carregados sob demanda
// via loadLocaleMessages: em dev isso corta ~1.500 requests do boot do
// dashboard; em prod, sai do bundle principal.
export default {
  en,
  pt_BR,
};

const lazyLocales = import.meta.glob('./locale/*/index.js');

export const loadLocaleMessages = async locale => {
  const load = lazyLocales[`./locale/${locale}/index.js`];
  if (!load) {
    throw new Error(
      `i18n: locale "${locale}" não existe em dashboard/i18n/locale`
    );
  }
  return (await load()).default;
};
